import React, { useEffect, useState } from 'react';
import { Star } from 'lucide-react';
import { LogoMark } from './graphics/Graphics';
export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`fixed top-0 left-0 right-0 z-50 h-[56px] bg-offwhite transition-shadow duration-300 ${scrolled ? 'shadow-subtle border-b-0' : 'border-b border-divider'}`} data-id="element-391">
      <div className="max-w-[1200px] mx-auto px-5 h-full flex items-center justify-between" data-id="element-392">
        {/* Left: Logo */}
        <div className="flex items-center gap-2" data-id="element-393">
          <LogoMark className="w-7 h-7 text-forest" data-id="element-394" />
          <div className="font-playfair text-[20px] text-ink font-semibold tracking-tight" data-id="element-395">
            DryControl™
          </div>
        </div>

        {/* Center: Trust Signals (Desktop only) */}
        <div className="hidden md:flex items-center space-x-4 text-[13px] font-inter text-secondary" data-id="element-396">
          <div className="flex items-center" data-id="element-397">
            <Star className="w-3.5 h-3.5 text-gold fill-gold mr-1" data-id="element-398" />
            <span data-id="element-399">4.8 Rating</span>
          </div>
          <span className="text-divider" data-id="element-400">|</span>
          <span data-id="element-401">11,200+ Reviews</span>
          <span className="text-divider" data-id="element-402">|</span>
          <span data-id="element-403">90-Day Guarantee</span>
        </div>

        {/* Right: CTA */}
        <button onClick={() => document.getElementById('bundles')?.scrollIntoView({
        behavior: 'smooth'
      })} className="bg-forest text-white font-inter font-semibold text-[14px] h-[36px] px-4 rounded-lg hover:bg-forest/90 transition-colors" data-id="element-404">
          Order Now
        </button>
      </div>
    </nav>;
}